import React from 'react';
import { useTranslation } from 'react-i18next';
import './FleetNodeCard.css';

export default function FleetNodeCard({ node, onUse, stopped = node.status !== 'online', statusText = node.description, ariaLabel, actionAriaLabel, badges, children }) {
  const { t } = useTranslation();
  const tone = stopped ? 'is-stopped' : node.color === 'yellow' ? 'is-busy' : node.hasStatus === false ? 'is-unknown' : '';

  return (
    <article className={`fleet-node-card fleet-unified-card ${stopped ? 'is-stopped' : ''}`}
      aria-label={ariaLabel || t('aiFleet.usageTags.nodeLabel', { id: node.id })}>
      <div className="fleet-card-heading">
        <h3>{node.id}</h3>
        {node.label && <span className="fleet-card-account">{node.label}</span>}
      </div>
      <div className={`fleet-card-status ${tone}`}>
        <span className="fleet-card-status-dot" aria-hidden="true" />
        <span>{statusText}</span>
        {badges}
      </div>
      <div className="fleet-card-details">{children}</div>
      <button type="button" className="fleet-card-action" disabled={stopped}
        aria-label={actionAriaLabel} onClick={() => onUse(node)}>
        {t(stopped ? 'aiFleet.nodeInfo.stopped' : 'aiFleet.nodeInfo.useNow')}
      </button>
    </article>
  );
}
